import { buildGeofencePolygonJson, normalizeEventZone } from "./eventZone";

/**
 * Saved-location (ELQR) normalization helpers, ported from the mobile app's
 * src/services/api/index.js (normalizeELQRLocation) and
 * src/Screens/add-location/utils/location.js.
 */

export const normalizeCheckInPoint = (point, index) => ({
  id: point?.id ?? point?.Id,
  name: point?.name ?? point?.Name ?? `Gate ${index + 1}`,
  latitude: Number(point?.latitude ?? point?.Latitude) || 0,
  longitude: Number(point?.longitude ?? point?.Longitude) || 0,
  radius: Number(point?.radius ?? point?.Radius) || 5,
  isActive: point?.isActive ?? point?.IsActive ?? true,
});

export const normalizeSavedLocation = (location) => ({
  Id: location?.Id ?? location?.id,
  LocationName: location?.LocationName ?? location?.locationName ?? "",
  Latitude: Number(location?.Latitude ?? location?.latitude) || 0,
  Longitude: Number(location?.Longitude ?? location?.longitude) || 0,
  Radius: Number(location?.Radius ?? location?.radius) || 25,
  Address: location?.Address ?? location?.address ?? "",
  City: location?.City ?? location?.city ?? "",
  Country: location?.Country ?? location?.country ?? "",
  LocationURL: location?.LocationURL ?? location?.locationURL ?? null,
  IsGeofenceEnabled: Boolean(location?.IsGeofenceEnabled ?? location?.isGeofenceEnabled),
  GeofencePolygonJson: location?.GeofencePolygonJson ?? location?.geofencePolygonJson ?? null,
  LocationCheckInPoints: (
    location?.LocationCheckInPoints ??
    location?.CheckInPoints ??
    location?.checkInPoints ??
    []
  ).map(normalizeCheckInPoint),
});

export const getCreatedLocationId = (response) => {
  const location = response?.ELQR ?? response?.Result?.ELQR ?? response?.Result ?? response;
  return (
    location?.Id ??
    location?.id ??
    location?.ELQRId ??
    location?.elqrId ??
    location?.PromoterELQRId ??
    location?.promoterELQRId ??
    null
  );
};

/**
 * @param {{name, pick: {address, latitude, longitude, city, country, radius}, zoneCoordinates}} args
 */
export const buildLocationPayload = ({ name, pick, zoneCoordinates }) => {
  const geofencePolygonJson = buildGeofencePolygonJson(zoneCoordinates);
  return {
    locationName: name,
    address: pick?.address,
    latitude: pick?.latitude,
    longitude: pick?.longitude,
    city: pick?.city,
    country: pick?.country,
    radius: pick?.radius,
    isGeofenceEnabled: Boolean(geofencePolygonJson),
    geofencePolygonJson,
    beforeMinutes: 60,
    afterMinutes: 60,
  };
};

/** Parse a saved location's stored geofence into map-editor draft points. */
export const savedLocationToZonePoints = (location) => {
  const zone = normalizeEventZone(location?.GeofencePolygonJson);
  return zone?.coordinates ?? [];
};
